<template>
    <template-block
        v-if="localModel"
        type="Hero"
        @toggle-collapsible="$emit('toggle-collapsible')"
        :open="open"
        @delete="$emit('delete')"
        :locked="value.locked"
        :position="value.position"
        :mode="mode"
        @update:locked="localModel.locked = $event; emitChange();"
        @update:position="localModel.position = $event; emitChange();"
    >
        <draggable v-model="localModel.blocks" group="base" handle=".handle" class="ecard-template-blocks mb-3" @sort="emitChange">
            <component
                v-for="(block, b_index) in localModel.blocks"
                :key="'b-' + block.id"
                :vid="vid + '.blocks.' + b_index"
                v-model="localModel.blocks[b_index]"
                :is="'block-' + block.type"
                :open="collapsible_state[block.id]"
                @toggle-collapsible="toggleCollapsible(block.id)"
                @delete="deleteBlock(block.id)"
                @input="emitChange"
                :mode="mode"
            ></component>
        </draggable>
        <div class="btn-group justify-content-center">
            <a href="#" class="btn btn-light dropdown-toggle" data-toggle="dropdown">Add content</a>

            <div class="dropdown-menu">
                <a href="#" @click.prevent="addBlock('text')" class="dropdown-item">Text</a>
                <a href="#" @click.prevent="addBlock('image')" class="dropdown-item">Bild</a>
                <a href="#" @click.prevent="addBlock('button')" class="dropdown-item">Knapp</a>
            </div>
        </div>
    </template-block>
</template>

<script>
import draggable from 'vuedraggable';
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import BlockButton from '@components/Ecard/BlockButton.vue';
import BlockDivider from '@components/Ecard/BlockDivider.vue';
import BlockFooter from '@components/Ecard/BlockFooter.vue';
import BlockImage from '@components/Ecard/BlockImage.vue';
import BlockRedeem from '@components/Ecard/BlockRedeem.vue';
import BlockText from '@components/Ecard/BlockText.vue';
import { genUUID } from '@services/Helpers';

export default {
    name: 'BlockHero',
    components: {
        draggable,
        TemplateBlock,
        BlockButton,
        BlockDivider,
        BlockFooter,
        BlockImage,
        BlockRedeem,
        BlockText,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        vid: {
            type: String,
            default: 'image.',
        },
        open: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        collapsible_state: {},
        localModel: null,
    }),
    mounted() {
        this.init(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
            },
        },
    },
    methods: {
        init(newVal) {
            let newBlocks = [];
            if (Array.isArray(newVal.blocks)) {
                const state = {};
                newBlocks = JSON.parse(JSON.stringify(newVal.blocks));
                newBlocks.forEach((b) => {
                    if (!Object.hasOwn(this.collapsible_state, b.id)) {
                        state[b.id] = false;
                    } else {
                        state[b.id] = this.collapsible_state[b.id];
                    }
                });
                this.collapsible_state = state;
            }

            this.localModel = {
                type: 'hero',
                id: newVal.id || genUUID(),
                backgroundColor: newVal.backgroundColor || '#FFFFFF',
                bgPosition: newVal.bgPosition || 'center center',
                bgUrl: newVal.bgUrl || '',
                mediaId: newVal.mediaId || null,
                blocks: newBlocks,
                locked: newVal.locked === undefined || newVal.locked === null ? false : newVal.locked,
            };
        },
        addBlock(type) {
            this.localModel.blocks.push({
                id: genUUID(),
                type,
            });
            this.emitChange();
        },
        toggleCollapsible(blockId) {
            if (!Object.hasOwn(this.collapsible_state, blockId)) {
                this.collapsible_state[blockId] = false;
            }
            this.collapsible_state[blockId] = !this.collapsible_state[blockId];
        },
        deleteBlock(blockId) {
            const index = this.localModel.blocks.findIndex((b) => b.id === blockId);
            if (index > -1) {
                this.localModel.blocks.splice(index, 1);
                this.emitChange();
            }
        },
        emitChange() {
            this.$emit('input', { ...this.localModel });
        },
    },
};
</script>

<style scoped>
.sortable-ghost {
    border: 1px dashed #aaa;
    position:relative;
    box-shadow: none;
    -webkit-box-shadow: none;
}
.sortable-ghost:before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    z-index: 10;
    padding: 20px;
}
</style>
